import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { clsx } from 'clsx';

import * as styles from './AnimatedContainer.css';

interface IAnimatedContainerProps {
  children: React.ReactNode;
  className?: string;
  percentVisible?: number;
  timeoutCallback?: number;
}

export const AnimatedContainer: React.FC<IAnimatedContainerProps> = ({
  children,
  percentVisible = 0.2,
  timeoutCallback = 0,
}) => {
  const [isAnimated, setIsAnimated] = React.useState(false);

  return (
    <ActionAfterViewed
      percentVisible={percentVisible}
      timeoutCallback={timeoutCallback}
      callback={() => {
        setIsAnimated(true);
      }}
    >
      <div className={clsx(styles['container'], isAnimated && styles['animated'])}>{children}</div>
    </ActionAfterViewed>
  );
};
